import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/logo-mt7rk.svg'
import _imports_1 from '@/assets/img/search.svg'
import _imports_2 from '@/assets/img/arrow.svg'
import _imports_3 from '@/assets/img/reset.svg'
import _imports_4 from '@/assets/img/calendar.svg'


const _hoisted_1 = {
  id: "logo",
  class: ""
}
const _hoisted_2 = { class: "box-shadow down" }
const _hoisted_3 = {
  id: "logo",
  class: ""
}
const _hoisted_4 = { class: "box-shadow down nohover" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "full"
}, null, -1)
const _hoisted_6 = { class: "nav-items" }
const _hoisted_7 = { class: "top" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "bottom" }
const _hoisted_11 = { class: "search-wrap" }
const _hoisted_12 = { class: "filters-wrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "من الاخبار", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" | News")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, " من متحرك", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" | From mt7rk")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "من المحركين", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" | Community")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "filters-wrap small" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "top" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "bottom noverflow" }
const _hoisted_30 = { class: "search-wrap" }
const _hoisted_31 = { class: "top" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "bottom" }
const _hoisted_35 = {
  key: 0,
  class: "search-wrap"
}
const _hoisted_36 = {
  key: 1,
  class: "search-wrap"
}
const _hoisted_37 = {
  key: 2,
  id: "maintype",
  class: "filters-wrap small"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode("RESET ")
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Cancel"
}, null, -1)
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = {
  id: "filterCountry",
  class: "flex wrap"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  id: "filterTags",
  class: "flex wrap"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 5,
  class: "cta-results filters-wrap small box-shadow bc-blue"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode("See results ")
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "box-shadow down right" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
  ])
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "box-shadow down right" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ])
], -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "box-shadow down right nohover" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ])
], -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "burger-wrap desktop" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "burger-button" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "burger-wrap mobile" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "burger-button" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  id: "navul",
  class: "flex column"
}
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Magazine")
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "مجلة", -1)
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Showcase")
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "معرض", -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Directory")
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "دليل", -1)
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = { id: "sub-nav" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("About mt7rk ")
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "عن متحرك", -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Contact Us")
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "تواصلوا معنا", -1)
const _hoisted_77 = [
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Privacy Policy ")
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "سياسة الخصوصية", -1)
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Submit a Tip")
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "شاركونا خبر", -1)
const _hoisted_83 = [
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = {
  key: 0,
  id: "agendaWrap",
  class: "box-shadow right reversed"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "مفكرة"),
  /*#__PURE__*/_createTextVNode("Calendar")
], -1)
const _hoisted_86 = { class: "date-box" }
const _hoisted_87 = { class: "info" }
const _hoisted_88 = {
  key: 0,
  class: "category"
}
const _hoisted_89 = { class: "location" }
const _hoisted_90 = ["innerHTML"]
const _hoisted_91 = {
  key: 0,
  id: "agendaWrap"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Calendar"),
  /*#__PURE__*/_createElementVNode("span", null, "مفكرة")
], -1)
const _hoisted_93 = { class: "top" }
const _hoisted_94 = { id: "searchWrap" }
const _hoisted_95 = { id: "dateWrap" }
const _hoisted_96 = /*#__PURE__*/_createStaticVNode("<option value=\"\">MONTH</option><option value=\"1\">JANUARY</option><option value=\"2\">FEBRUARY</option><option value=\"3\">MARCH</option><option value=\"4\">APRIL</option><option value=\"5\">MAY</option><option value=\"6\">JUNE</option><option value=\"7\">JULY</option><option value=\"8\">AUGUST</option><option value=\"9\">SEPTEMBER</option><option value=\"10\">OCTOBER</option><option value=\"11\">NOVEMBER</option><option value=\"12\">DECEMBER</option>", 13)
const _hoisted_109 = [
  _hoisted_96
]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "YEAR", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("option", { value: "2022" }, "2022", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("option", { value: "2023" }, "2023", -1)
const _hoisted_113 = [
  _hoisted_110,
  _hoisted_111,
  _hoisted_112
]
const _hoisted_114 = { class: "filters-wrap" }
const _hoisted_115 = ["onClick"]
const _hoisted_116 = { class: "date-box" }
const _hoisted_117 = { class: "info" }
const _hoisted_118 = {
  key: 0,
  class: "category"
}
const _hoisted_119 = { class: "location" }
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { class: "search-wrap" }
const _hoisted_123 = {
  key: 0,
  class: "filters-wrap"
}
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", null, "من الاخبار", -1)
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" | News")
const _hoisted_126 = [
  _hoisted_124,
  _hoisted_125
]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", null, " من متحرك", -1)
const _hoisted_128 = /*#__PURE__*/_createTextVNode(" | From mt7rk")
const _hoisted_129 = [
  _hoisted_127,
  _hoisted_128
]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("span", null, "من المحركين", -1)
const _hoisted_131 = /*#__PURE__*/_createTextVNode(" | Community")
const _hoisted_132 = [
  _hoisted_130,
  _hoisted_131
]
const _hoisted_133 = {
  key: 1,
  class: "filters-wrap small"
}
const _hoisted_134 = ["onClick"]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = {
  key: 1,
  class: "direct"
}
const _hoisted_138 = {
  key: 0,
  class: "search-wrap"
}
const _hoisted_139 = {
  key: 1,
  class: "search-wrap"
}
const _hoisted_140 = {
  key: 2,
  id: "maintype",
  class: "filters-wrap small"
}
const _hoisted_141 = /*#__PURE__*/_createTextVNode("RESET ")
const _hoisted_142 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Cancel"
}, null, -1)
const _hoisted_143 = [
  _hoisted_141,
  _hoisted_142
]
const _hoisted_144 = {
  id: "filterCountryMob",
  class: "flex wrap"
}
const _hoisted_145 = ["onClick"]
const _hoisted_146 = {
  id: "filterTagsMob",
  class: "flex wrap"
}
const _hoisted_147 = ["onClick"]
const _hoisted_148 = {
  key: 5,
  class: "filters-wrap small border bc-white cta-results"
}
const _hoisted_149 = /*#__PURE__*/_createTextVNode("See results ")
const _hoisted_150 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_151 = [
  _hoisted_149,
  _hoisted_150
]
const _hoisted_152 = /*#__PURE__*/_createTextVNode("See results ")
const _hoisted_153 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_154 = [
  _hoisted_152,
  _hoisted_153
]

export function render(_ctx, _cache) {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")

  return (_openBlock(), _createElementBlock("div", {
    id: "navBar",
    class: _normalizeClass([_ctx.page, (_ctx.scrolled ? 'scrolled': ''), (_ctx.navOpen ? 'open' : ''), (_ctx.calOpen ? 'calendar' : '')])
  }, [
    _createElementVNode("div", {
      id: "logoBtn",
      class: "logo-btn active desktop",
      onClick: _cache[2] || (_cache[2] = $event => (_ctx.goHome())),
      onMouseover: _cache[3] || (_cache[3] = $event => (_ctx.overAnim('logoL'))),
      onMouseout: _cache[4] || (_cache[4] = $event => (_ctx.outAnim('logoL')))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (this.page != 'directory' && this.page != 'directest' && this.page != 'directorypost' && this.page != 'directorypostdraft' && this.page != 'directorysearch' && this.page != 'awards' && this.page != 'awardspost' && this.page != 'awardspostdraft' && this.page != 'awardssearch')
            ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 0,
                ref: "logoL",
                id: "logoLettie",
                animationData: _ctx.LogoJSON,
                height: 180,
                width: 380,
                loop: false
              }, null, 8, ["animationData"]))
            : (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 1,
                ref: "logoL",
                id: "logoLettie",
                animationData: _ctx.LogoBlueJSON,
                height: 180,
                width: 380,
                loop: false
              }, null, 8, ["animationData"])),
          (_ctx.ArrowJSON)
            ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 2,
                ref: "arrowL",
                class: "arrow",
                animationData: _ctx.ArrowJSON,
                height: 70,
                width: 70,
                loop: true,
                autoPlay: false,
                onMouseover: _cache[0] || (_cache[0] = $event => (_ctx.overAnim('arrowL'))),
                onMouseout: _cache[1] || (_cache[1] = $event => (_ctx.outAnim('arrowL')))
              }, null, 8, ["animationData"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 32),
    _createElementVNode("div", {
      id: "logoBtn",
      class: "logo-btn active mobile",
      onClick: _cache[5] || (_cache[5] = $event => (_ctx.goHome()))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (this.page != 'directory' && this.page != 'directest' && this.page != 'directorypost' && this.page != 'directorypostdraft' && this.page != 'directorysearch' && this.page != 'awards' && this.page != 'awardspost' && this.page != 'awardspostdraft' && this.page != 'awardssearch')
            ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 0,
                ref: "logoLMob",
                id: "logoLettieM",
                animationData: _ctx.LogoJSON,
                height: 160,
                width: 355,
                loop: false
              }, null, 8, ["animationData"]))
            : (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 1,
                ref: "logoLMob",
                id: "logoLettieM",
                animationData: _ctx.LogoBlueJSON,
                height: 160,
                width: 355,
                loop: false
              }, null, 8, ["animationData"])),
          (_ctx.ArrowJSON)
            ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 2,
                ref: "arrowLMob",
                class: "arrow",
                animationData: _ctx.ArrowJSON,
                height: 70,
                width: 70,
                loop: true,
                autoPlay: false
              }, null, 8, ["animationData"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["nav-item", [_ctx.page == 'blog' || _ctx.page == 'blogpost' || _ctx.page == 'blogpostdraft' || _ctx.page == 'content' || _ctx.page == 'community' || _ctx.page == 'news' || _ctx.page == 'newspost' || _ctx.page == 'newspostdraft' || _ctx.page == 'search' || _ctx.page == 'tag'|| _ctx.page == 'cat' || _ctx.page == 'pageView' || _ctx.page == 'authorView' ? ['active'] : '', _ctx.search ? ['open'] : '']])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["box-shadow down", {'reversed': _ctx.page == 'blog'}])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "search-icon",
                onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)), ["stop"]))
              }, _hoisted_9),
              _createElementVNode("a", {
                class: "arabic",
                href: "",
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.goTo('blog',null,$event)))
              }, "مجلة"),
              _createElementVNode("a", {
                class: "english",
                href: "",
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.goTo('blog',null,$event)))
              }, "magazine")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.searchContent) = $event)),
                  onClick: _cache[10] || (_cache[10] = _withModifiers($event => (_ctx.enableSearch()), ["stop"])),
                  onKeyup: _cache[11] || (_cache[11] = _withKeys($event => (_ctx.handleSearch()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.searchContent]
                ]),
                _createElementVNode("img", {
                  src: _imports_2,
                  onClick: _cache[12] || (_cache[12] = _withModifiers($event => (_ctx.handleSearch()), ["stop"]))
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  class: "filter",
                  onClick: _cache[13] || (_cache[13] = _withModifiers($event => (_ctx.goTo('news')), ["stop"]))
                }, _hoisted_15),
                _createElementVNode("a", {
                  class: "filter",
                  onClick: _cache[14] || (_cache[14] = _withModifiers($event => (_ctx.goTo('content')), ["stop"]))
                }, _hoisted_18),
                _createElementVNode("a", {
                  class: "filter",
                  onClick: _cache[15] || (_cache[15] = _withModifiers($event => (_ctx.goTo('community')), ["stop"]))
                }, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                (_ctx.tags)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tags, (tag, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: _normalizeClass(["filter red", {'active': _ctx.searchTag == tag.slug, 'hide': index > 10 && !_ctx.moreTags}]),
                        onClick: $event => (_ctx.goToTag(tag.slug))
                      }, _toDisplayString(tag.name), 11, _hoisted_23))
                    }), 256))
                  : _createCommentVNode("", true),
                (!_ctx.moreTags)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "",
                      class: "show-more red",
                      onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.showMoreTags && _ctx.showMoreTags(...args)))
                    }, _hoisted_25))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-item", [_ctx.page == 'awards' ? ['active'] : '', _ctx.search ? ['open'] : '']])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["box-shadow down", {'reversed': _ctx.page == 'awards'}])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", {
                class: "search-icon",
                onClick: _cache[17] || (_cache[17] = _withModifiers((...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)), ["stop"]))
              }, _hoisted_28),
              _createElementVNode("a", {
                class: "arabic",
                href: "",
                onClick: _cache[18] || (_cache[18] = $event => (_ctx.goTo('awards',null,$event)))
              }, "معرض"),
              _createElementVNode("a", {
                class: "english",
                href: "",
                onClick: _cache[19] || (_cache[19] = $event => (_ctx.goTo('awards',null,$event)))
              }, "showcase")
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.searchContent) = $event)),
                  onClick: _cache[21] || (_cache[21] = _withModifiers($event => (_ctx.enableSearch()), ["stop"])),
                  onKeyup: _cache[22] || (_cache[22] = _withKeys($event => (_ctx.handleSearch()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.searchContent]
                ]),
                _createElementVNode("img", {
                  src: _imports_2,
                  onClick: _cache[23] || (_cache[23] = _withModifiers($event => (_ctx.handleSearch()), ["stop"]))
                })
              ])
            ])
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-item", [_ctx.page == 'directory' || _ctx.page == 'directest' || _ctx.page == 'directorypost' || _ctx.page == 'directorypostdraft' || _ctx.page == 'directorysearch' ? ['active'] : '', _ctx.search ? ['open'] : '']])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["box-shadow down right", {'reversed': _ctx.page == 'directory'}])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", {
                class: "search-icon",
                onClick: _cache[24] || (_cache[24] = (...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)))
              }, _hoisted_33),
              _createElementVNode("a", {
                class: "arabic",
                href: "",
                onClick: _cache[25] || (_cache[25] = $event => (_ctx.goTo('directory',null,$event)))
              }, "دليل"),
              _createElementVNode("a", {
                class: "english",
                href: "",
                onClick: _cache[26] || (_cache[26] = $event => (_ctx.goTo('directory',null,$event)))
              }, "directory")
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_ctx.page == 'directest')
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      placeholder: "Search",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => ((_ctx.searchDirectory) = $event)),
                      onClick: _cache[28] || (_cache[28] = $event => (_ctx.enableSearch())),
                      onKeyup: _cache[29] || (_cache[29] = _withKeys($event => (_ctx.handleSearch('directory')), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.searchDirectory]
                    ]),
                    _createElementVNode("img", {
                      src: _imports_2,
                      onClick: _cache[30] || (_cache[30] = $event => (_ctx.handleSearch('directory')))
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _withDirectives(_createElementVNode("input", {
                      placeholder: "Search",
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => ((_ctx.searchContent) = $event)),
                      onClick: _cache[32] || (_cache[32] = $event => (_ctx.enableSearch())),
                      onKeyup: _cache[33] || (_cache[33] = _withKeys($event => (_ctx.handleSearch()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.searchContent]
                    ]),
                    _createElementVNode("img", {
                      src: _imports_2,
                      onClick: _cache[34] || (_cache[34] = $event => (_ctx.handleSearch()))
                    })
                  ])),
              (_ctx.page == 'directest')
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_ctx.searchType == 'individual' || _ctx.searchType == 'all')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "filter blue solo flex center align-center active",
                          onClick: _cache[35] || (_cache[35] = $event => (_ctx.setFilter('company','type','del','Companies')))
                        }, "FREELANCER"))
                      : (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: "filter blue solo flex center align-center",
                          onClick: _cache[36] || (_cache[36] = $event => (_ctx.setFilter('individual','type','add','Freelancer')))
                        }, "FREELANCER")),
                    (_ctx.searchType == 'company' || _ctx.searchType == 'all')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 2,
                          class: "filter blue solo flex center align-center active",
                          onClick: _cache[37] || (_cache[37] = $event => (_ctx.setFilter('individual','type','del','Freelancer')))
                        }, "COMPANIES"))
                      : (_openBlock(), _createElementBlock("p", {
                          key: 3,
                          class: "filter blue solo flex center align-center",
                          onClick: _cache[38] || (_cache[38] = $event => (_ctx.setFilter('company','type','add','Companies')))
                        }, "COMPANIES")),
                    (_ctx.searchType != 'all' || _ctx.searchCountry != 'all' || _ctx.searchTag != 'all')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 4,
                          class: _normalizeClass(["reset type filter flex center align-center", {'active': _ctx.searchType == 'all'}]),
                          onClick: _cache[39] || (_cache[39] = $event => (_ctx.setFilter('all','type')))
                        }, _hoisted_40, 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.directoryCountries && _ctx.directoryCountries.length > 0 && _ctx.page == 'directest')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(["filters-wrap small bc-blue secondary box-shadow", {'open':_ctx.currentFilter == 'filterCountry', 'default':!_ctx.currentFilter || _ctx.currentFilter == 'filterTags'}])
                  }, [
                    _createElementVNode("p", {
                      class: "title",
                      onClick: _cache[40] || (_cache[40] = $event => (_ctx.openFilter('filterCountry')))
                    }, "COUNTRIES"),
                    _createElementVNode("a", {
                      class: "toggle",
                      onClick: _cache[41] || (_cache[41] = $event => (_ctx.openFilter('filterCountry')))
                    }),
                    _createElementVNode("div", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directoryCountries, (country) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: _normalizeClass(["filter blue flex center align-center", {'active': _ctx.searchCountry == country}]),
                          onClick: $event => (_ctx.setFilterCountry(country,'country',country))
                        }, _toDisplayString(country), 11, _hoisted_42))
                      }), 256))
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.directoryTags && _ctx.directoryTags.length > 0  && _ctx.page == 'directest')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(["filters-wrap small box-shadow bc-blue secondary", {'open':_ctx.currentFilter == 'filterTags', 'default':!_ctx.currentFilter || _ctx.currentFilter == 'filterCountry'}])
                  }, [
                    _createElementVNode("p", {
                      class: "title",
                      onClick: _cache[42] || (_cache[42] = $event => (_ctx.openFilter('filterTags')))
                    }, "TAGS"),
                    _createElementVNode("a", {
                      class: "toggle",
                      onClick: _cache[43] || (_cache[43] = $event => (_ctx.openFilter('filterTags')))
                    }),
                    _createElementVNode("div", _hoisted_43, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directoryTags, (tag) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: _normalizeClass(["filter blue flex center align-center", {'active': _ctx.searchTag == tag.slug || _ctx.selectedTags.indexOf(tag.slug) > -1}]),
                          onClick: $event => (_ctx.tagSelection(tag,_ctx.selectedTags.indexOf(tag.slug) > -1))
                        }, _toDisplayString(tag.name), 11, _hoisted_44))
                      }), 256))
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.page != 'directory' && _ctx.page != 'directest')
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("a", {
                      class: "flex center align-center",
                      href: "",
                      onClick: _cache[44] || (_cache[44] = $event => (_ctx.goTo('directory',null,$event)))
                    }, _hoisted_48)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2)
      ], 2)
    ]),
    _createElementVNode("div", {
      id: "calendarBtn",
      onClick: _cache[45] || (_cache[45] = (...args) => (_ctx.toggleCalendar && _ctx.toggleCalendar(...args)))
    }, _hoisted_50),
    _createElementVNode("div", {
      class: "search-icon desktop",
      onClick: _cache[46] || (_cache[46] = (...args) => (_ctx.toggleSearchMenu && _ctx.toggleSearchMenu(...args)))
    }, _hoisted_52),
    _createElementVNode("div", {
      class: "search-icon mobile",
      onClick: _cache[47] || (_cache[47] = (...args) => (_ctx.toggleSearchMenu && _ctx.toggleSearchMenu(...args)))
    }, _hoisted_54),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", {
        class: "box-shadow down right",
        onClick: _cache[48] || (_cache[48] = (...args) => (_ctx.toggleNav && _ctx.toggleNav(...args)))
      }, _hoisted_57)
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", {
        class: "box-shadow down right nohover",
        onClick: _cache[49] || (_cache[49] = (...args) => (_ctx.toggleNav && _ctx.toggleNav(...args)))
      }, _hoisted_60)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["open-nav", {'visible': _ctx.navOpen}])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[50] || (_cache[50] = $event => (_ctx.goTo('blog')))
            }, _hoisted_64),
            _createElementVNode("li", {
              onClick: _cache[51] || (_cache[51] = $event => (_ctx.goTo('awards')))
            }, _hoisted_67),
            _createElementVNode("li", {
              onClick: _cache[52] || (_cache[52] = $event => (_ctx.goTo('directory')))
            }, _hoisted_70)
          ]),
          _createElementVNode("ul", _hoisted_71, [
            _createElementVNode("li", {
              onClick: _cache[53] || (_cache[53] = $event => (_ctx.goTo('pageView',2)))
            }, _hoisted_74),
            _createElementVNode("li", {
              onClick: _cache[54] || (_cache[54] = $event => (_ctx.goTo('pageView',527)))
            }, _hoisted_77),
            _createElementVNode("li", {
              onClick: _cache[55] || (_cache[55] = $event => (_ctx.goTo('pageView',3)))
            }, _hoisted_80),
            _createElementVNode("li", {
              onClick: _cache[56] || (_cache[56] = $event => (_ctx.goTo('pageView',529)))
            }, _hoisted_83)
          ])
        ]),
        (_ctx.events)
          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
              _hoisted_85,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events.slice(0,2), (event) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("p", null, _toDisplayString(event.custom_fields.date.split('/')[0]), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.getMonthName(event.custom_fields.date.split('/')[1])), 1),
                      _createElementVNode("p", null, _toDisplayString(event.custom_fields.date.split('/')[2]), 1)
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      (event.category[0])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(event.category[0].name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("h4", null, _toDisplayString(event.post_title), 1),
                      _createElementVNode("p", _hoisted_89, _toDisplayString(event.custom_fields.location), 1),
                      _createElementVNode("div", {
                        innerHTML: event.post_content
                      }, null, 8, _hoisted_90)
                    ])
                  ]))
                }), 256))
              ]),
              _createElementVNode("a", {
                onClick: _cache[57] || (_cache[57] = (...args) => (_ctx.toggleCalendar && _ctx.toggleCalendar(...args)))
              }, "All upcoming events")
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["open-cal", {'visible': _ctx.calOpen}])
    }, [
      _createElementVNode("div", null, [
        (_ctx.events)
          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Search",
                    "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => ((_ctx.searchContent) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchContent]
                  ])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _withDirectives(_createElementVNode("select", {
                    id: "selectMonth",
                    onChange: _cache[59] || (_cache[59] = $event => (_ctx.monthChange())),
                    "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => ((_ctx.monthFilter) = $event))
                  }, _hoisted_109, 544), [
                    [_vModelSelect, _ctx.monthFilter]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    id: "selectYear",
                    onChange: _cache[61] || (_cache[61] = $event => (_ctx.yearChange())),
                    "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => ((_ctx.yearFilter) = $event))
                  }, _hoisted_113, 544), [
                    [_vModelSelect, _ctx.yearFilter]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                (_ctx.eventTags)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "filter",
                      onClick: _cache[63] || (_cache[63] = $event => (_ctx.setTag('all')))
                    }, "ALL"))
                  : _createCommentVNode("", true),
                (_ctx.eventTags)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.eventTags, (tag) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass(["filter", {'active': _ctx.searchTag == tag.slug}]),
                        onClick: $event => (_ctx.setTag(tag.slug))
                      }, _toDisplayString(tag.name), 11, _hoisted_115))
                    }), 256))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass([[event.custom_fields.language], {'hidden': (_ctx.searchTag != 'all' && !_ctx.hasTag(event)) || 
                                                                (_ctx.searchContent && 
                                                                event.post_title.toLowerCase().indexOf(_ctx.searchContent.toLowerCase()) == -1 && 
                                                                event.post_content.toLowerCase().indexOf(_ctx.searchContent.toLowerCase()) == -1 &&
                                                                event.custom_fields.location.toLowerCase().indexOf(_ctx.searchContent.toLowerCase()) == -1) ||
                                                                (_ctx.monthFilter !== '' && _ctx.yearFilter !== '' && (parseInt(event.custom_fields.date.split('.')[1]) != parseInt(_ctx.monthFilter) || parseInt(event.custom_fields.date.split('.')[2]) != parseInt(_ctx.yearFilter))) ||
                                                                (_ctx.monthFilter !== '' && parseInt(event.custom_fields.date.split('.')[1]) != parseInt(_ctx.monthFilter)) ||
                                                                (_ctx.yearFilter !== '' && parseInt(event.custom_fields.date.split('.')[2]) != parseInt(_ctx.yearFilter)) }])
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("p", null, _toDisplayString(event.custom_fields.date.split('/')[0]), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.getMonthName(event.custom_fields.date.split('/')[1])), 1),
                        _createElementVNode("p", null, _toDisplayString(event.custom_fields.date.split('/')[2]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        (event.category[0])
                          ? (_openBlock(), _createElementBlock("p", _hoisted_118, _toDisplayString(event.category[0].name), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("h4", null, _toDisplayString(event.post_title), 1),
                        _createElementVNode("p", _hoisted_119, _toDisplayString(event.custom_fields.location), 1),
                        _createElementVNode("div", {
                          innerHTML: event.post_content
                        }, null, 8, _hoisted_120)
                      ])
                    ])
                  ], 2))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["open-search", {'visible': _ctx.searchOpen}])
    }, [
      (_ctx.page == 'blog' || _ctx.page == 'blogpost' || _ctx.page == 'awards')
        ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "Search",
                "onUpdate:modelValue": _cache[64] || (_cache[64] = $event => ((_ctx.searchContent) = $event)),
                onKeyup: _cache[65] || (_cache[65] = _withKeys($event => (_ctx.handleSearch()), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.searchContent]
              ]),
              _createElementVNode("img", {
                src: _imports_2,
                onClick: _cache[66] || (_cache[66] = _withModifiers($event => (_ctx.handleSearch()), ["stop"]))
              })
            ]),
            (_ctx.page != 'awards')
              ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                  _createElementVNode("p", {
                    class: "filter",
                    onClick: _cache[67] || (_cache[67] = _withModifiers($event => (_ctx.goTo('news')), ["stop"]))
                  }, _hoisted_126),
                  _createElementVNode("p", {
                    class: "filter",
                    onClick: _cache[68] || (_cache[68] = _withModifiers($event => (_ctx.goTo('content')), ["stop"]))
                  }, _hoisted_129),
                  _createElementVNode("p", {
                    class: "filter",
                    onClick: _cache[69] || (_cache[69] = _withModifiers($event => (_ctx.goTo('community')), ["stop"]))
                  }, _hoisted_132)
                ]))
              : _createCommentVNode("", true),
            (_ctx.page != 'awards')
              ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                  (_ctx.tags)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tags, (tag, index) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: _normalizeClass(["filter", {'active': _ctx.searchTag == tag.slug, 'hide': index > 10 && !_ctx.moreTags}]),
                          onClick: $event => (_ctx.goToTag(tag.slug))
                        }, _toDisplayString(tag.name), 11, _hoisted_134))
                      }), 256))
                    : _createCommentVNode("", true),
                  (!_ctx.moreTags)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "",
                        class: "show-more",
                        onClick: _cache[70] || (_cache[70] = (...args) => (_ctx.showMoreTags && _ctx.showMoreTags(...args)))
                      }, _hoisted_136))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.page == 'directory' || _ctx.page == 'directest' || _ctx.page == 'directorypost' || _ctx.page == 'directorysearch')
        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
            (_ctx.page == 'directest')
              ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Search",
                    "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => ((_ctx.searchDirectory) = $event)),
                    onKeyup: _cache[72] || (_cache[72] = _withKeys($event => (_ctx.handleSearch('directory')), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.searchDirectory]
                  ]),
                  _createElementVNode("img", {
                    src: _imports_2,
                    onClick: _cache[73] || (_cache[73] = _withModifiers($event => (_ctx.handleSearch('directory')), ["stop"]))
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_139, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Search",
                    "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => ((_ctx.searchContent) = $event)),
                    onKeyup: _cache[75] || (_cache[75] = _withKeys($event => (_ctx.handleSearch()), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.searchContent]
                  ]),
                  _createElementVNode("img", {
                    src: _imports_2,
                    onClick: _cache[76] || (_cache[76] = _withModifiers($event => (_ctx.handleSearch()), ["stop"]))
                  })
                ])),
            (_ctx.page == 'directest')
              ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                  (_ctx.searchType == 'individual' || _ctx.searchType == 'all')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "filter solo blue flex center align-center active",
                        onClick: _cache[77] || (_cache[77] = $event => (_ctx.setFilter('company','type','del','Companies')))
                      }, "FREELANCER"))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: "filter blue flex center align-center",
                        onClick: _cache[78] || (_cache[78] = $event => (_ctx.setFilter('individual','type','add','Freelancer')))
                      }, "FREELANCER")),
                  (_ctx.searchType == 'company' || _ctx.searchType == 'all')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 2,
                        class: "filter solo blue flex center align-center active",
                        onClick: _cache[79] || (_cache[79] = $event => (_ctx.setFilter('individual','type','del','Freelancer')))
                      }, "COMPANIES"))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 3,
                        class: "filter blue flex center align-center",
                        onClick: _cache[80] || (_cache[80] = $event => (_ctx.setFilter('company','type','add','Companies')))
                      }, "COMPANIES")),
                  (_ctx.searchType != 'all' || _ctx.searchCountry != 'all' || _ctx.searchTag != 'all')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 4,
                        class: _normalizeClass(["reset type filter flex center align-center", {'active': _ctx.searchType == 'all'}]),
                        onClick: _cache[81] || (_cache[81] = $event => (_ctx.setFilter('all','type')))
                      }, _hoisted_143, 2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.directoryCountries && _ctx.directoryCountries.length > 0  && _ctx.page == 'directest')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: _normalizeClass(["filters-wrap small border bc-white secondary", {'open':_ctx.currentFilter == 'filterCountryMob', 'default':!_ctx.currentFilter || _ctx.currentFilter == 'filterTagsMob'}])
                }, [
                  _createElementVNode("p", {
                    class: "title",
                    onClick: _cache[82] || (_cache[82] = $event => (_ctx.openFilter('filterCountryMob')))
                  }, "COUNTRIES"),
                  _createElementVNode("a", {
                    class: "toggle",
                    onClick: _cache[83] || (_cache[83] = $event => (_ctx.openFilter('filterCountryMob')))
                  }),
                  _createElementVNode("div", _hoisted_144, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directoryCountries, (country) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: _normalizeClass(["filter blue flex center align-center", {'active': _ctx.searchCountry == country}]),
                        onClick: $event => (_ctx.setFilterCountry(country,'country','add'))
                      }, _toDisplayString(country), 11, _hoisted_145))
                    }), 256))
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.directoryTags && _ctx.directoryTags.length > 0  && _ctx.page == 'directest')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(["filters-wrap small border bc-white secondary", {'open':_ctx.currentFilter == 'filterTagsMob', 'default':!_ctx.currentFilter || _ctx.currentFilter == 'filterCountryMob'}])
                }, [
                  _createElementVNode("p", {
                    class: "title",
                    onClick: _cache[84] || (_cache[84] = $event => (_ctx.openFilter('filterTagsMob')))
                  }, "TAGS"),
                  _createElementVNode("a", {
                    class: "toggle",
                    onClick: _cache[85] || (_cache[85] = $event => (_ctx.openFilter('filterTagsMob')))
                  }),
                  _createElementVNode("div", _hoisted_146, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directoryTags, (tag) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: _normalizeClass(["filter blue flex center align-center", {'active': _ctx.searchTag == tag.slug || _ctx.selectedTags.indexOf(tag.slug) > -1}]),
                        onClick: $event => (_ctx.tagSelection(tag,_ctx.selectedTags.indexOf(tag.slug) > -1))
                      }, _toDisplayString(tag.name), 11, _hoisted_147))
                    }), 256))
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.page == 'directest')
              ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                  (_ctx.page == 'directory' || _ctx.page == 'directest')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "flex center align-center",
                        onClick: _cache[86] || (_cache[86] = (...args) => (_ctx.toggleNav && _ctx.toggleNav(...args)))
                      }, _hoisted_151))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "flex center align-center",
                        href: "",
                        onClick: _cache[87] || (_cache[87] = $event => (_ctx.goTo('directory',null,$event)))
                      }, _hoisted_154))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}